import { createRestSlice } from "./restSlice";

export type AgentExtraction = {
  id: string;
  sessionId: string;
  evaluatorId: string;
  extraction?: Record<string, unknown> | string;
  extractionSchema?: Record<string, unknown>;
  error: boolean;
  createdAt: Date;
  updatedAt: Date;
  deletedAt: Date | null;
};

const agentExtractionSlice = createRestSlice<AgentExtraction>("agentExtractions", "/v1/agents/:agentId/evaluators/:evaluatorId/extractions");

export const agentExtractionReducer = agentExtractionSlice.reducer;
export const agentExtractionActions = agentExtractionSlice.actions;
